<template>
  <el-dialog :title="isEdit ? '编辑配置' : '新增配置'"
             :visible.sync="dialogVisible"
             width="600px"
             @close="handleClose">
    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="150px">
      <el-form-item label="提货区域"
                    prop="takeAreaName">
        <!-- <el-input v-model="form.takeAreaName"
                  placeholder="请输入提货区域">
        </el-input> -->
        <el-select v-model="form.takeAreaName"
                   placeholder="请输入提货区域"
                   clearable
                   filterable>
          <el-option v-for="(item) of areaList"
                     :key="item.id"
                     :label="item.areaName"
                     :value="item.areaName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务归属"
                    prop="hyhnProcess">
        <el-radio-group v-model="form.hyhnProcess">
          <el-radio :label="1">山东炼厂</el-radio>
          <el-radio :label="2">海南炼厂</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="工厂编码"
                    prop="factoryCode">
        <el-input v-model="form.factoryCode"
                  placeholder="请输入工厂编码">
        </el-input>
      </el-form-item>
      <el-form-item label="SAP库区编码"
                    prop="sapWarehouseAreaCode">
        <el-input v-model="form.sapWarehouseAreaCode"
                  placeholder="请输入SAP库区编码">
        </el-input>
      </el-form-item>
      <el-form-item label="SAP库区名称"
                    prop="sapWarehouseAreaName">
        <el-input v-model="form.sapWarehouseAreaName"
                  placeholder="请输入SAP库区名称">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary"
                 @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    },
    areaList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form: {
        takeAreaName: '',
        factoryCode: '',
        sapWarehouseAreaCode: '',
        hyhnProcess: '',
        sapWarehouseAreaName: ''
      },
      rules: {
        takeAreaName: [
          { required: true, message: '请输入提货区域', trigger: 'blur' }
        ],
        factoryCode: [
          { required: true, message: '请输入工厂编码', trigger: 'blur' }
        ],
        sapWarehouseAreaCode: [
          { required: true, message: '请输入SAP库区编码', trigger: 'blur' }
        ],
        sapWarehouseAreaName: [
          { required: true, message: '请输入SAP库区名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  watch: {
    info: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.form = { ...newVal }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions('haiyunSapWarehouse', ['addHaiyunSapWarehouse', 'updateHaiyunSapWarehouse']),
    handleClose () {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm () {
      this.form = {
        takeAreaName: '',
        factoryCode: '',
        sapWarehouseAreaCode: '',
        sapWarehouseAreaName: ''
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.updateHaiyunSapWarehouse(this.form).then(res => {
              this.$message.success('编辑成功')
              this.handleClose()
              this.$emit('reloadTable')
            }).catch(error => {
              console.error('编辑失败:', error)
              this.$message.error('编辑失败，请重试')
            })
          } else {
            this.addHaiyunSapWarehouse(this.form).then(res => {
              this.$message.success('新增成功')
              this.handleClose()
              this.$emit('reloadTable')
            }).catch(error => {
              console.error('新增失败:', error)
              this.$message.error('新增失败，请重试')
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
